import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { formatPrettyDate } from "@/utils/date-utils";
import { useLocation } from "react-router-dom";
import { getMemberInfo } from "@/hooks/useMembers";
import usePetCare from "@/hooks/usePetCare";
import MLoader from "@/components/ui/atoms/MLoader";
import FormHeader from "@/components/ui/organisms/MHeader";
import { getMemberName } from "@/utils/member";
import MSelectCard from "@/components/ui/atoms/MSelectCard";
import MEmptyCard from "@/components/ui/organisms/MEmptyCard";
import { IconPaw } from "@tabler/icons-react";
import MSpacer from "@/components/ui/atoms/MSpacer";

const PetCareHistory: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const petCareType = location.state?.petCareType;
  const memberInfo = getMemberInfo();
  const name = getMemberName(memberInfo);
  const memberId = memberInfo.id;
  const { loading, history, fetchHistory } = usePetCare(memberId);

  useEffect(() => {
    fetchHistory(petCareType);
  }, [petCareType]);

  if (loading) {
    return <MLoader />;
  }

  return (
    <div className="profile-page-root">
      {/* Header */}
      <FormHeader
        module="petcare"
        memberInfo={memberInfo}
        title={t(`petcare.${petCareType}_history`, { name })}
        description={t(`petcare.${petCareType}_history.description`, { name })}
        showGradient={true}
      />
      <MSpacer mt={24} />
      {/* History List */}
      <div className="flex flex-col gap-3">
        {history.length === 0 ? (
          <MEmptyCard
            icon={<IconPaw />}
            primaryTitle={t(`petcare.noHistoryFound.${petCareType.toLowerCase()}`)}
          />
        ) : (
          <>
            {history.map((item, index) => (
              <MSelectCard
                key={index}
                text={formatPrettyDate(item.dueDate)}
                className="w-full"
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default PetCareHistory;
